import { render, staticRenderFns } from "./DashboardWorkspace.vue?vue&type=template&id=2cba3a7e"
import script from "./DashboardWorkspace.vue?vue&type=script&lang=js"
export * from "./DashboardWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports